// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import Block, { BlockProps } from "@store/Library/Components/Toolkit/Block";
import { infoProps } from "@store/Themes/common/props/info";
import { orderProps } from "@store/Themes/common/props/order";
import useQueryString from "@toolkit/Framework/Common/Hooks/useQueryString";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { useWishListState } from "@toolkit/Framework/Store/Data/MyLists/MyListsHooks";
import React, { FC } from "react";

type Props = WidgetProps;

export interface StaticListInformationStyles {
    block?: BlockProps;
    infoGridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    infoLabel?: TypographyPresentationProps;
    infoValue?: TypographyPresentationProps;
}

export const staticListInformationStyles: StaticListInformationStyles = {
    block: orderProps.block,
    infoGridContainer: infoProps.grid?.container,
    infoGridItem: infoProps.grid?.item,
    infoLabel: mergeProps<StaticListInformationStyles["infoLabel"]>(infoProps.label, { forwardAs: "h2" }),
    infoValue: infoProps.value,
};

const styles = staticListInformationStyles;

const StaticListInformation: FC<Props> = () => {
    const { id } = useQueryString();
    const { value: wishList } = useWishListState(id);

    if (!wishList) {
        return null;
    }

    return (
        <Block {...styles.block}>
            <GridContainer {...styles.infoGridContainer}>
                <GridItem {...styles.infoGridItem}>
                    <Typography {...styles.infoLabel}>{translate("Shared by")}</Typography>
                    <Typography {...styles.infoValue}>{wishList.sharedByDisplayName}</Typography>
                </GridItem>
            </GridContainer>
        </Block>
    );
};

const widgetModule: WidgetModule = {
    component: StaticListInformation,
    definition: {
        group: "Static List",
        displayName: "Information",
        allowedContexts: ["StaticListPage"],
    },
};
export default widgetModule;
